import tinycolor from 'tinycolor2';

export const itemDateColor = date => {
    let timestamp = new Date(date).getTime();
    const color = '#' +(timestamp + Math.pow(16, 6)).toString(16).slice(-6).toUpperCase();
    const brightness = tinycolor(color).getBrightness();
    return brightness > 150 ? tinycolor(color).darken(40).toString() : color;  
}